import styled from "styled-components";

import { Container } from "../../styles/commonStyles";
import * as Styles from "../../styles/userProfileAndJobDetailStyles";

import { mediaMaxWidth } from "../../utils/mediaQuery";
import FAQsSection from "./FAQsSection";

const FAQAndSimilarJobsSection = ({
	faqData = undefined,
	source,
	showFaqOnly,
	sectionBgColor,
}) => (
	<Main bgColor={sectionBgColor}>
		<FAQSectionContainer>
			<Styles.RowContainer>
				<Styles.MainContentColumns clean>
					<FAQsSection
						faqData={faqData}
						source={source}
						showFaqOnly={showFaqOnly}
					/>
					<BrandLinesContainer>
						<BrandLines backgroundColor="#2bb793" />
						<BrandLines backgroundColor="#83bde4" />
						<BrandLines backgroundColor="#ffd166" />
					</BrandLinesContainer>
				</Styles.MainContentColumns>
			</Styles.RowContainer>
		</FAQSectionContainer>
	</Main>
);

const Main = styled.section`
	background-color: ${(props) => props.bgColor || "transparent"};
`;

const BrandLinesContainer = styled.div`
	display: flex;
	margin: 50px -80px 0;

	${mediaMaxWidth.medium`
		margin: 30px -15px 0;
    `}
`;
const BrandLines = styled.div`
	height: 6px;
	width: 100%;
	background-color: ${({ backgroundColor }) => backgroundColor};
`;

const FAQSectionContainer = styled(Container)`
	& ${Styles.RowContainer} {
		padding-top: 70px;
		padding-bottom: 50px;
	}
	& ${Styles.RowContainer} ${Styles.MainContentColumns} {
		border-radius: 4px;
		box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.05);
		border: solid 1px #dddddd;
		background-color: #ffffff;
		padding: 80px 80px 0;
		overflow-x: hidden;
	}
	${mediaMaxWidth.medium`

		& ${Styles.RowContainer} ${Styles.MainContentColumns} {
			padding: 40px 15px 0 !important;
		}

		& ${Styles.RowContainer} {
			flex-wrap: wrap;
			padding-top: 45px;
			padding-bottom: 45px;
		}

		& ${Styles.RowContainer} ${Styles.CTAColumns}:last-child {
			width: 100%;
			max-width: 100%;
			padding: 0;
		}
	`};
`;

export default FAQAndSimilarJobsSection;
